import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const agentApi = axios.create({ baseURL: API });

agentApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_agent_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

agentApi.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const authRelated =
      status === 401 &&
      (detail === "Invalid token" ||
        detail === "Token expired" ||
        detail === "Not authenticated" ||
        detail === "Invalid token type" ||
        detail === "Agent not found");
    if (authRelated && typeof window !== "undefined") {
      try { localStorage.removeItem("ss_agent_token"); } catch (_) {}
      if (window.location.pathname.startsWith("/agent") && window.location.pathname !== "/agent/login") {
        window.location.replace("/agent/login");
      }
    }
    return Promise.reject(error);
  }
);

export default agentApi;
